import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAttendanceReports } from '../interfaces/attendance';

@Injectable({
  providedIn: 'root',
})
export class AttendanceService {
  constructor(private httpClient: HttpClient) {}

  getAttendanceReports(url: string, filters: any): Observable<IAttendanceReports> {
    return this.httpClient.get<IAttendanceReports>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<IAttendanceReports>;
  }

  createAttendance(url: string, attendanceForm: any): Observable<any> {
    return this.httpClient.post<any>(url, attendanceForm, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }
}
